import { Field, Model } from 'serialize-ts';
import { ProductIndexPrice } from '~app/modules/product/models/product-index-price.model';
import { ProductIndexTime } from '~app/modules/product/models/product-index-time.interface';

@Model()
export class ProductIndexShipping {
  @Field()
  price: ProductIndexPrice;

  @Field()
  time: ProductIndexTime;
}
